import $ from 'jquery';

function toggleDescription () {
  const $parent = $(this).parent('[data-el-faq-card]')
  const $icon = $parent.find('[data-el-icon]')
  const $description = $parent.find('[data-el-description]')
  $icon.toggleClass('is-open');
  $description.slideToggle(200);
}

function clickHandle (index, object) {
  const $header = $(object).find('[data-el-header]')

  $header.on('click', toggleDescription);
}

export default class FaqCard {
  init () {
    // console.log('FaqCard init')

    $('[data-el-faq-card]').each((index, object) => {
      clickHandle(index, object)
    })
  }
}
